<template v-slot:message>
  <div>
    <ParagraphBody>
      Test Device Management with policies.
    </ParagraphBody>
    <ButtonSecondary
      :data-test-id="$testId('addButton')"
      text="Add"
      @click="addFeature"
    />
  </div>
</template>

<script>
import {
  ButtonSecondary,
  ParagraphBody,
} from '@jumpcloud/ui-components';
import {
  eventLocations,
  eventProperties,
  keepGoingNotificationId,
  onboardingFeatureDisplayNames,
  onboardingFeatures,
} from 'client/GrowthEngineering/utilities/GrowthConstants';
import { implementationChecklists } from 'client/components/ImplementationChecklist/ImplementationChecklists';
import { mapActions } from 'vuex';
import { notificationModuleName as notificationModule } from '@jumpcloud/ui-notifications';
import EventHelper from 'client/GrowthEngineering/EventHelper';

const onboardingModule = 'OnboardingModule';

const {
  description,
  location,
  section,
  text,
} = eventProperties;

export default {
  name: 'KeepGoingNotification',

  components: {
    ButtonSecondary,
    ParagraphBody,
  },

  methods: {
    ...mapActions(onboardingModule, [
      'addFeatureToImplementationChecklist',
    ]),

    ...mapActions(notificationModule, [
      'removeNotification',
    ]),

    addFeature() {
      const deviceChecklist = implementationChecklists[onboardingFeatures.deviceManagement];
      this.addFeatureToImplementationChecklist(deviceChecklist);
      EventHelper.triggerButtonClicked({
        [description]: `Adds ${onboardingFeatureDisplayNames.deviceManagement} feature to checklist`,
        [location]: eventLocations.discoverPage,
        [section]: 'Keep Going Notification',
        [text]: 'Add',
      });
      this.removeNotification({ id: keepGoingNotificationId });
    },
  },
};
</script>
